/* ============================================================
   CK | Upsell Carousel Initialization
   Handles product selection, hidden input sync, and cart filtering
============================================================ */
(function () {
  function initCkUpsellCarousel(root) {
    const wrappers = (root || document).querySelectorAll('.ck-upsell-carousel');
    if (!wrappers.length) return;

    const cartPromise = fetch('/cart.js', { credentials: 'same-origin' })
      .then((r) => r.json())
      .catch(() => null);

    wrappers.forEach((wrapper) => {
      if (wrapper.dataset.ckUpsellInit === '1') return;
      wrapper.dataset.ckUpsellInit = '1';

      const cards = wrapper.querySelectorAll('.ck-upsell-carousel__card');
      if (!cards.length) {
        wrapper.classList.add('ck-upsell-carousel--hidden');
        return;
      }

      const form =
        wrapper.closest('form[action*="/cart/add"]') ||
        document.querySelector('form[action*="/cart/add"].shopify-product-form') ||
        document.querySelector('form.shopify-product-form');

      if (!form) {
        return;
      }

      wrapper.style.opacity = '0';
      wrapper.style.transition = 'opacity 0.25s ease';

      cartPromise.then((cart) => {
        if (!cart || !Array.isArray(cart.items)) {
          wrapper.style.opacity = '1';
          return;
        }

        let hadVisible = false;

        cards.forEach((card) => {
          const vid = card.dataset.variantId;
          if (!vid) return;

          const inCart = cart.items.some((item) => String(item.id) === String(vid));
          if (inCart) {
            card.style.opacity = '0';
            card.style.display = 'none';
          } else {
            hadVisible = true;
          }
        });

        if (!hadVisible) wrapper.classList.add('ck-upsell-carousel--hidden');
        wrapper.style.opacity = '1';
      });

      cards.forEach((card) => {
        const toggle = card.querySelector('.ck-upsell-carousel__toggle');
        if (!toggle) return;

        toggle.addEventListener('click', (ev) => {
          ev.preventDefault();
          card.classList.toggle('is-selected');
          syncUpsellHiddenInputs(form, wrapper);
        });
      });
    });
  }

  function syncUpsellHiddenInputs(form, wrapper) {
    const oldInputs = form.querySelectorAll('.ck-upsell-hidden-input');
    oldInputs.forEach((el) => el.remove());

    const selected = wrapper.querySelectorAll('.ck-upsell-carousel__card.is-selected');
    if (!selected.length) return;

    let index = 1;
    selected.forEach((card) => {
      const vid = card.dataset.variantId;
      if (!vid) return;

      const idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = `items[${index}][id]`;
      idInput.value = vid;
      idInput.className = 'ck-upsell-hidden-input';

      const qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = `items[${index}][quantity]`;
      qtyInput.value = '1';
      qtyInput.className = 'ck-upsell-hidden-input';

      form.appendChild(idInput);
      form.appendChild(qtyInput);
      index++;
    });
  }

  document.addEventListener('DOMContentLoaded', () => initCkUpsellCarousel(document));
  document.addEventListener('shopify:section:load', (e) => initCkUpsellCarousel(e.target));
  document.addEventListener('shopify:section:reorder', (e) => initCkUpsellCarousel(e.target));
})();

/* ============================================================
   CK | Drag Scrolling for Desktop
============================================================ */
(function () {
  const track = document.querySelector('.ck-upsell-carousel__track');
  if (!track) return;

  let isDragging = false;
  let startX = 0;
  let scrollStart = 0;

  track.querySelectorAll('img, p').forEach((el) => {
    el.addEventListener('dragstart', (e) => e.preventDefault());
  });

  track.addEventListener('pointerdown', (e) => {
    if (e.target.closest('.ck-upsell-carousel__toggle')) return;
    isDragging = true;
    startX = e.clientX;
    scrollStart = track.scrollLeft;
    track.classList.add('is-dragging');
  });

  track.addEventListener('pointermove', (e) => {
    if (!isDragging) return;
    const diff = e.clientX - startX;
    track.scrollLeft = scrollStart - diff;
  });

  track.addEventListener('pointerup', stopDragging);
  track.addEventListener('pointerleave', stopDragging);

  function stopDragging() {
    if (!isDragging) return;
    isDragging = false;
    track.classList.remove('is-dragging');
  }

  track.addEventListener('contextmenu', (e) => e.preventDefault());
})();

/* ============================================================
   CK | Helper — hide wrapper if no cards visible
============================================================ */
function updateUpsellWrapperVisibility(wrapper) {
  const visibleCards = wrapper.querySelectorAll(
    '.ck-upsell-carousel__card:not([style*="display: none"])'
  );

  if (!visibleCards.length) {
    wrapper.classList.add('ck-upsell-carousel--hidden');
  } else {
    wrapper.classList.remove('ck-upsell-carousel--hidden');
  }
}

/* ============================================================
   CK | Hide Upsell Cards Once Added to Cart
============================================================ */
function clearUpsellHiddenInputs() {
  document.querySelectorAll('.ck-upsell-hidden-input').forEach((el) => el.remove());
}

(function () {
  document.addEventListener('product:added', async (e) => {
    try {
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
      if (!cart || !Array.isArray(cart.items)) return;

      const cartHandles = cart.items.map((i) => i.handle);
      const cartIds = cart.items.map((i) => String(i.id));

      document.querySelectorAll('.ck-upsell-carousel__card').forEach((card) => {
        const cardVid = card.dataset.variantId;
        const cardHandle = card.dataset.productHandle;

        const matched =
          (cardVid && cartIds.includes(cardVid)) ||
          (cardHandle && cartHandles.includes(cardHandle));

        if (matched) {
          clearUpsellHiddenInputs();

          card.style.transition = 'opacity 0.25s ease';
          card.style.opacity = '0';
          card.classList.remove('is-selected');

          setTimeout(() => {
            card.style.display = 'none';

            const wrapper = card.closest('.ck-upsell-carousel');
            if (wrapper) updateUpsellWrapperVisibility(wrapper);
          }, 250);
        }
      });
    } catch (err) {
      console.error('[CK Upsell] Failed to check cart or remove upsells', err);
    }
  });
})();

/* ============================================================
   CK | Show Upsell Cards Again When Product Removed from Cart
============================================================ */
(function () {
  async function refreshUpsellCarousel() {
    try {
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
      if (!cart || !Array.isArray(cart.items)) return;

      const cartHandles = cart.items.map((i) => i.handle);
      const cartIds = cart.items.map((i) => String(i.id));

      document.querySelectorAll('.ck-upsell-carousel').forEach((wrapper) => {
        wrapper.classList.remove('ck-upsell-carousel--hidden');
        const track = wrapper.querySelector('.ck-upsell-carousel__track');

        let reappeared = false;

        wrapper.querySelectorAll('.ck-upsell-carousel__card').forEach((card) => {
          const cardVid = card.dataset.variantId;
          const cardHandle = card.dataset.productHandle;

          const inCart =
            (cardVid && cartIds.includes(cardVid)) ||
            (cardHandle && cartHandles.includes(cardHandle));

          card.style.transition = 'opacity 0.25s ease';

          if (inCart) {
            card.style.opacity = '0';
            setTimeout(() => {
              card.style.display = 'none';
            }, 250);
          } else {
            if (card.style.display === 'none' || card.style.opacity === '0') {
              reappeared = true;
            }
            card.style.display = 'flex';
            setTimeout(() => {
              card.style.opacity = '1';
            }, 25);
          }
        });

        updateUpsellWrapperVisibility(wrapper);

        if (reappeared && track) {
          track.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
        }
      });
    } catch (err) {
      console.error('[CK Upsell] Failed to refresh upsell carousel', err);
    }
  }

  document.body.addEventListener('click', (e) => {
    const removeBtn = e.target.closest('[data-action="remove-item"]');
    if (!removeBtn) return;

    // cart updates async → wait until Shopify finishes
    setTimeout(() => {
      refreshUpsellCarousel();
    }, 400);
  });
})();

// document.addEventListener('product:added', (e) => {
//   console.log('source:', e.target);
// });
